import React from 'react';
import BoxIcon from './../assets/images/box.svg';
const ListEmpty = (props) => {
    const {message} = props;
    return(
        <div className="list-empty-holder">
            <img src={BoxIcon} width={180} />
            <div className="message">
                {message}
            </div>
        </div>
    )
};

export default ListEmpty;